/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2024] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import StringCell from '@/backgrid/StringCell';
import GridView from '@/views/GridView';
import HorizontalAddressCell from '@/views/HorizontalAddressCell.js/HorizontalAddressCell';
import showModal from '@/util/showModal';

import ButtonCell from '../../../common/backgrid/ButtonCell';
import KOInformationModal from '../KOInformationModal';

const KOInformationGrid = GridView.extend({
  options: {
    pageSize: 25
  },

  initialize() {
    const self = this;
    this.options.columns = [
      {
        name: 'regionGroup',
        label: 'Branch',
        cell: StringCell,
        headerCell: 'custom',
        width: 8,
        editable: false,
        sortable: true
      },
      {
        name: 'name',
        label: 'Name',
        cell: StringCell,
        headerCell: 'custom',
        width: 15,
        editable: false,
        sortable: true
      },
      {
        name: 'addressId',
        label: 'Address ID',
        cell: StringCell,
        headerCell: 'custom',
        width: 15,
        editable: false,
        sortable: true,
        renderable: false
      },
      {
        name: 'address',
        label: 'Address',
        cell: HorizontalAddressCell,
        headerCell: 'custom',
        width: 20,
        editable: false,
        sortable: true
      },
      {
        name: 'pocName',
        label: 'POC Name',
        cell: StringCell,
        headerCell: 'custom',
        width: 10,
        editable: false,
        sortable: true
      },
      {
        name: 'pocEmail',
        label: 'Email',
        cell: StringCell,
        headerCell: 'custom',
        width: 13,
        editable: false,
        sortable: true
      },
      {
        name: 'pocPhone',
        label: 'Telephone',
        cell: StringCell,
        headerCell: 'custom',
        width: 10,
        editable: false,
        sortable: true
      },
      {
        name: 'pgr',
        label: 'PGr',
        cell: StringCell,
        headerCell: 'custom',
        width: 8,
        editable: false,
        sortable: true
      },
      {
        name: 'pgcCode',
        label: 'PGC Code',
        cell: StringCell,
        headerCell: 'custom',
        width: 5,
        editable: false,
        sortable: true
      },
      {
        name: 'isActiveText',
        label: 'Status',
        cell: StringCell,
        headerCell: 'custom',
        width: 5,
        editable: false,
        sortable: true
      },
      {
        name: 'edit',
        label: '',
        editable: false,
        sortable: false,
        width: 7,
        cell: ButtonCell.extend({
          buttonClass: 'btn btn-sm btn-outline-primary text-center',
          name() {
            return 'Edit';
          },
          onClick(e, model) {
            self.openEditKOModal(e, model);
          }
        })
      }
    ];

    this.options.collection = this.model.get('collection');
    this.options.emptyText = 'No KO Information Found';
    GridView.prototype.initialize?.apply(this, this.options);
  },

  async openEditKOModal(e, model) {
    const self = this;
    if (e?.type) e.preventDefault();
    model.set('regions', this.model.get('regions'));
    model.set('regionGroups', this.model.get('regionGroups'));

    await showModal({
      title: 'Edit KO Information',
      view: new KOInformationModal({
        model
      }),
      dialogClasses: 'modal-lg'
    }).then(async (modalData) => {
      self.saveRowItem(modalData, model);
    });
  },

  async saveRowItem(modalData, model) {
    model.set('regionGroup', modalData.regionGroup);
    model.set('regionGroupId', modalData.regionGroupId);
    model.set('name', modalData.name);
    model.set('addressId', modalData.addressId);
    model.set('address', modalData.address);
    model.set('pocName', modalData.pocName);
    model.set('pocEmail', modalData.pocEmail);
    model.set('pocPhone', modalData.pocPhone);
    model.set('pocFax', modalData.pocFax);
    model.set('pgr', modalData.pgr);
    model.set('pgcCode', modalData.pgcCode);
    model.set('isActiveText', modalData.isActiveText);
  }
});

export default KOInformationGrid;
